import { App } from './App';
import { BrowserRouter } from "react-router";
import ReactDOM from "react-dom/client"

const container = document.getElementById("app")!;
const root = ReactDOM.createRoot(container)
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
